import { IconProps } from './IconProps';

export const CheckCircleSF = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="42"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_240_54)">
        <path
          d="M9.96094 19.9219C15.459 19.9219 19.9219 15.459 19.9219 9.96094C19.9219 4.46289 15.459 0 9.96094 0C4.46289 0 0 4.46289 0 9.96094C0 15.459 4.46289 19.9219 9.96094 19.9219ZM9.96094 18.2617C5.37109 18.2617 1.66016 14.5508 1.66016 9.96094C1.66016 5.37109 5.37109 1.66016 9.96094 1.66016C14.5508 1.66016 18.2617 5.37109 18.2617 9.96094C18.2617 14.5508 14.5508 18.2617 9.96094 18.2617Z"
          fill={props.fill ?? '#000000'}
          fill-opacity="0.85"
        />
        <path
          d="M8.88672 14.5996C9.20898 14.5996 9.48242 14.4434 9.67773 14.1406L14.1406 7.11914C14.248 6.92383 14.375 6.70898 14.375 6.49414C14.375 6.05469 13.9844 5.77148 13.5742 5.77148C13.3301 5.77148 13.0859 5.92773 12.9004 6.21094L8.84766 12.7148L6.92383 10.2246C6.68945 9.91211 6.47461 9.83398 6.20117 9.83398C5.78125 9.83398 5.44922 10.1758 5.44922 10.6055C5.44922 10.8203 5.53711 11.0254 5.67383 11.2109L8.05664 14.1406C8.30078 14.4629 8.56445 14.5996 8.88672 14.5996Z"
          fill={props.fill ?? '#000000'}
          fill-opacity="0.85"
        />
      </g>
      <defs>
        <clipPath id="clip0_240_54">
          <rect width="20.2832" height="19.9316" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
